import { render, staticRenderFns } from "./ExpiredPicklsPopup.vue?vue&type=template&id=a845e59c&scoped=true&"
import script from "./ExpiredPicklsPopup.vue?vue&type=script&lang=ts&"
export * from "./ExpiredPicklsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ExpiredPicklsPopup.vue?vue&type=style&index=0&id=a845e59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a845e59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a845e59c')) {
      api.createRecord('a845e59c', component.options)
    } else {
      api.reload('a845e59c', component.options)
    }
    module.hot.accept("./ExpiredPicklsPopup.vue?vue&type=template&id=a845e59c&scoped=true&", function () {
      api.rerender('a845e59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/ExpiredPicklsPopup.vue"
export default component.exports